import { render } from "./ActUnbindingButton.vue?vue&type=template&id=72aa3fd1"
import script from "./ActUnbindingButton.vue?vue&type=script&lang=js"
export * from "./ActUnbindingButton.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__